

import Game from '../Components/Game';

import Header from '../Components/Header';
import EllaButton from '../Components/EllaButton';
import MikeyButton from '../Components/MikeyButton';
import MemoryLane from '../Components/MemoryLane';

const Home = ({ }) => {

    return (
        <div
        className='home-container'
        >

            <Header 
            title={'mikey & eleanor'}
            page={"Home"}/>

            <video 
            className='home-video'
            controls>
                <source 
                src="/assets/intro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div
            style={{
                minHeight: '5%'
            }} 
            />

            <div
            className='story-time'
            onClick={() => {

                setTimeout(() => {
                    window.location.href = '/story';
                }
                , 300);
            }}
            >
                Story Time

            </div>

            <EllaButton 
            style={{
                margin: 'auto'
            }}
            />

            <MikeyButton 
            style={{
                margin: 'auto'
            }}
            />

            <div
            style={{
                minHeight: '5%'
            }} 
            />

            <div>
                <Game />
            </div>

            <h2>Take a trip down memory lane!</h2>

            <video 
            className='home-video'
            controls>
                <source 
                src="/assets/ella_dance.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div
            style={{
                minHeight: '200px'
            }}
            />
            
        </div>
    )

};

export default Home;